import { adapter } from '@seek/tealium-adapter';

import type { AnalyticsOptions, Adapter, Analytics } from '../types';

let currentPage = '',
  authenticationFlow = '';

const createAnalytics = (options: AnalyticsOptions): Analytics => {
  const { link, view }: Adapter = adapter({});

  return {
    trackPageView: (props) => {
      currentPage = props.page;
      authenticationFlow = props.authenticationFlow ?? '';
      if (currentPage === 'registration form') {
        props.registrationFlow = 'new user';
      }
      view(props.page, {
        currentPage,
        ...props,
        ...options,
      });
    },
    trackLink: (props) => {
      const { isThirdPartyLink = 'false', ...restProps } = props;

      link(props.eventName, {
        currentPage,
        isThirdPartyLink,
        ...(authenticationFlow && { authenticationFlow }),
        ...options,
        ...restProps,
      });
    },
  };
};

export default createAnalytics;
